import { render, staticRenderFns } from "./DeliveryContentUploader.vue?vue&type=template&id=e35c236c&"
import script from "./DeliveryContentUploader.vue?vue&type=script&lang=js&"
export * from "./DeliveryContentUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports